import { APITransport } from '@client/transports/api';

/**
 * @typedef {{
 *   name: string;
 *   default: string;
 *   hide: boolean;
 *   transform: boolean;
 * }} Param
 */

/**
 * @typedef {{
 *   _id: string;
 *   template: string;
 *   params: Param[];
 *   rulename: string;
 *   status: boolean;
 * }} Background
 */

/**
 * @typedef {{
 *   csvtreenodebindings: any[];
 *   googlegroupbindings: any[];
 *   googleorgbindings: any[];
 *   o365groupbindings: any[];
 *   oktagroupbindings: any[];
 * }} Exclusions
 */

/**
 * @typedef {{
 *   _id: string;
 *   csvtreenodebindings: any[];
 *   exclusions: Exclusions;
 *   googlegroupbindings: any[];
 *   googleorgbindings: any[];
 *   groupname: string;
 *   o365groupbindings: any[];
 *   oktagroupbindings: any[];
 *   outlookaddin: { disableRemoveDefaultSignature: boolean };
 *   params: any[];
 *   senderexclusions: any[];
 *   senders: Array<{ username: string }>;
 *   tags: any[];
 *   uihelpers: any[];
 * }} SenderGroup
 */

/**
 * @typedef {{
 *   label: string;
 *   value: string;
 * }} SelectedGroup
 */

/**
 * @typedef {{
 *   _id: string;
 *   bizcard: Background;
 *   blockname: string;
 *   color: string;
 *   priority: number;
 *   selectedGroups: SelectedGroup[];
 *   sendergroups: SenderGroup[];
 *   status: boolean;
 *   tags: any[];
 * }} Route
 */

export const VirtualBackgroundRoutingService = {
  /** @param {Route} body */
  deleteRoute(body) {
    // Debug Log
    console.log('VirtualBackgroundRoutingService.deleteRoute', {
      path: 'POST /rest/domain/delete/brandkitroutes',
      body
    });
    return APITransport.post({
      path: '/rest/domain/delete/brandkitroutes',
      body
    });
  },
  /** @param {{ email: string }} body */
  findByEmail(body) {
    // Debug Log
    console.log('VirtualBackgroundRoutingService.findByEmail', { path: 'POST /rest/domain/findbrandkit', body });
    return APITransport.post({
      path: '/rest/domain/execute/findbrandkits',
      body
    });
  },
  getAll() {
    // Debug Log
    console.log('VirtualBackgroundRoutingService.getAll', { path: 'GET /rest/domain/brandkitroutes' });
    return APITransport.get({
      path: '/rest/domain/brandkitroutes'
    });
  },
  /** @param {string[]} orderedArray */
  saveRouteOrder(orderedArray) {
    // Debug Log
    console.log('VirtualBackgroundRoutingService.saveRouteOrder', {
      path: 'POST /rest/domain/reorderbrandkitroutes',
      body: orderedArray
    });
    return APITransport.post({
      path: '/rest/domain/execute/reorderbrandkitroutes',
      body: {
        orderedArray
      }
    });
  },
  /** @param {Route} body */
  updateRoute(body) {
    // Debug Log
    console.log('VirtualBackgroundRoutingService.saveRouteOrder', { path: 'POST /rest/domain/brandkitroutes', body });
    return APITransport.post({
      path: '/rest/domain/save/brandkitroutes',
      body
    });
  }
};
